const state = {
  tenantListPageSize: 10,
  tenantListCurrentPage: 1,
  clientListPageSize: 10,
  clientListCurrentPage: 1,
  identityResourceListPageSize: 10,
  identityResourceListCurrentPage: 1,
  apiResourceListPageSize: 10,
  apiResourceListCurrentPage: 1,
}
const getters = {
	tenantListPageSize: state => {
      return state.tenantListPageSize;
  },    
	tenantListCurrentPage: state => {
      return state.tenantListCurrentPage;
  },
  clientListPageSize: state => {
      return state.clientListPageSize;
  },
  clientListCurrrentPage: state => {
    return state.clientListCurrentPage;
  },
  identityResourceListPageSize: state => {
    return state.identityResourceListPageSize;
  },
  identityResourceListCurrentPage: state => {
    return state.identityResourceListCurrentPage;
  },
  apiResourceListPageSize: state => {
    return state.apiResourceListPageSize;
  },
  apiResourceListCurrentPage: state => {
    return state.apiResourceListCurrentPage;
  }
}
const mutations = {
  SET_TENANTLIST_PAGESIZE(state, pageSize) {
    state.tenantListPageSize = pageSize;
  },
  SET_TENANTLIST_CURRENTPAGE(state, page) {
    state.tenantListCurrentPage = page;
  },
  SET_CLIENTLIST_PAGESIZE(state, pageSize) {
    state.clientListPageSize = pageSize;
  },
  SET_CLIENTLIST_CURRENTPAGE(state, page) {
    state.clientListCurrentPage = page;
  },    
  SET_IDENTITYRESOURCELIST_PAGESIZE(state, pageSize) {
    state.identityResourceListPageSize = pageSize;
  },
  SET_IDENTITYRESOURCELIST_CURRENTPAGE(state, page) {
    state.identityResourceListCurrentPage = page;
  },
  SET_APIRESOURCELIST_PAGESIZE(state, pageSize) {
    state.apiResourceListPageSize = pageSize;
  },
  SET_APIRESOURCELIST_CURRENTPAGE(state, page) {
    state.apiResourceListCurrentPage = page;
  },
}
const actions = {
  tenantListPageSize : (context, value) => {
    context.commit("SET_TENANTLIST_PAGESIZE", value);
  },
  tenantListCurrentPage : (context, value) => {
    context.commit("SET_TENANTLIST_CURRENTPAGE", value);
  },
  clientListPageSize : (context, value) => {
    context.commit("SET_CLIENTLIST_PAGESIZE", value);
  },
  clientListCurrentPage : (context, value) => {
    context.commit("SET_CLIENTLIST_CURRENTPAGE", value);
  },    
  identityResourceListPageSize : (context, value) => {
    context.commit("SET_IDENTITYRESOURCELIST_PAGESIZE", value);
  },
  identityResourceListCurrentPage : (context, value) => {
    context.commit("SET_IDENTITYRESOURCELIST_CURRENTPAGE", value);
  },
  apiResourceListPageSize : (context, value) => {
    context.commit("SET_APIRESOURCELIST_PAGESIZE", value);
  },
  apiResourceListCurrentPage : (context, value) => {
    context.commit("SET_APIRESOURCELIST_CURRENTPAGE", value);
  },
}
export default {
  state, getters, mutations, actions
} 
